import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from '../../utils/utils';

export const getProposalDetails = (pn, cb) => async (dispatch) => {
  dispatch({ type: actionType.LOADER_TRUE });
  const { data } = await axios.get(
    `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/get/proposal/${pn}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      },
    }
  );
  try {
    dispatch({ type: actionType.LOADER_FALSE });
    dispatch({
      type: actionType.PROPOSAL_DATA,
      payload: { ...data.body.mcustomerResponse },
    });
    if (cb) {
      cb(data.body.mcustomerResponse);
    }
    toaster('success', data.message);
  } catch (e) {
    toaster('error', data.message);
    dispatch({ type: actionType.LOADER_FALSE });
  }
};

export const downloadImage = (img, pn, token) => (dispatch) => {
  dispatch({
    type: actionType.IMG_DOWNLOAD,
    payload: {
      name: img,
      src: '',
    },
  });
  axios
    .get(
      `${
        apiConstants().PROPOSEL_API_URL
      }api/v1/proposal/document/download?file=${img}&proposalNo=${pn}`,
      {
        headers: {
          authorization: localStorage.getItem('token'),
        },
        cancelToken: token,
        responseType: 'blob',
      }
    )
    .then((resp) => {
      let src = URL.createObjectURL(resp.data);

      dispatch({
        type: actionType.IMG_DOWNLOAD,
        payload: {
          name: img,
          src: src,
        },
      });
    })
    .catch((err) => console.log('err', err));
};

export const clearPreviewlist = (previewList) => (dispatch) => {
  previewList.map((item) => {
    URL.revokeObjectURL(item.src);
  });
  dispatch({
    type: actionType.IMG_DOWNLOAD,
    payload: 'clear',
  });
};

export const disableProposalAction = (pn, cb) => async (dispatch) => {
  dispatch({ type: actionType.LOADER_TRUE });
  try {
    const res = await axios.put(
      `${
        apiConstants().PROPOSEL_API_URL
      }api/v1/proposal/disable/submit?proposalNo=${pn}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: localStorage.getItem('token'),
        },
      }
    );
    dispatch({ type: actionType.LOADER_FALSE });
    toaster('success', res.data.message);
    if (cb) {
      cb(res.data);
    }
  } catch (e) {
    dispatch({ type: actionType.LOADER_FALSE });
  }
};

export const enableDisableProposalAction =
  (pn, disableFlag, cb) => async (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    try {
      const res = await axios.put(
        `${
          apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/disable/submit?disableProposal=${disableFlag}&proposalNo=${pn}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('token'),
          },
        }
      );
      dispatch({ type: actionType.LOADER_FALSE });
      toaster('success', res.data.message);
      if (cb) {
        cb(res.data);
      }
    } catch (e) {
      dispatch({ type: actionType.LOADER_FALSE });
    }
  };

export const fetchStatus = (uid, cb) => (dispatch) => {
  axios
    .post(
      `${
        apiConstants().PROPOSEL_API_URL
      }api/v1/proposal/insta2-required/${uid}`,
      '',
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: localStorage.getItem('token'),
        },
      }
    )
    .then((resp) => {
      if (resp && resp.data.body) {
        dispatch({
          type: actionType.FETCH_APP_STATUS,
          payload: resp.data.body,
        });
        toaster('success', resp.data.message);
      } else {
        toaster('error', resp.data.message);
      }
      if (cb) {
        cb(resp.data.body);
      }
    })
    .catch((err) => {
      if (err.status === '401') {
        dispatch({
          type: actionType.AGENT_LOGIN,
          payload: false,
        });
      }
    });
};

export const triggerInsta2Notification =
  (proposalNo, cb) => async (dispatch) => {
    axios
      .post(
        `${
          apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/insta2-notification/${proposalNo}`,
        '',
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('token'),
          },
        }
      )
      .then((resp) => {
        if (resp && resp.status === 200) {
          toaster('success', resp.data.message);
          if (cb) {
            cb(resp.data);
          }
        } else {
          toaster('error', resp.data.message);
        }
      })
      .catch((err) => {
        if (err.status === '401') {
          dispatch({
            type: actionType.AGENT_LOGIN,
            payload: false,
          });
        }
      });
  };
export const consentByPass =
  (proposalNumber, selectedValue) => async (dispatch) => {
    const payloadData = {
      proposalNumber: proposalNumber,
      bypassType: selectedValue,
    };
    axios
      .post(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/consent/bypass`,
        '',
        {
          headers: {
            'Content-Type': 'application/json',
            ...payloadData,
            authorization: localStorage.getItem('token'),
          },
        }
      )
      .then((resp) => {
        if (resp && resp.status === 200) {
          toaster('success', resp.data.message);
        } else {
          toaster('error', resp.data.message);
        }
      })
      .catch((err) => {
        if (err.status === '401') {
          dispatch({
            type: actionType.BYPASS_CONSENT,
            payload: false,
          });
        }
      });
  };

export const getProposalValidation = (pn, cb) => async (dispatch) => {
  let data;
  try {
    dispatch({ type: actionType.LOADER_TRUE });
    data = await axios.post(
      `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/sb/validation`,
      pn,
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: localStorage.getItem('token'),
        },
      }
    );
    dispatch({ type: actionType.LOADER_FALSE });
    dispatch({
      type: actionType.PROPOSAL_DATA,
      payload: { ...data.body },
    });
    if (cb) {
      cb(data?.data);
    }
  } catch (e) {
    dispatch({ type: actionType.LOADER_FALSE });
    toaster('error', data?.data?.message);
  }
};

export const untagPolicy = (param, cb) => async (dispatch) => {
  let data;
  try {
    dispatch({ type: actionType.LOADER_TRUE });
    data = await axios.post(
      `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/sb/unTagPolicy`,
      param,
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: localStorage.getItem('token'),
        },
      }
    );

    dispatch({ type: actionType.LOADER_FALSE });
    dispatch({
      type: actionType.PROPOSAL_DATA,
      payload: { ...data?.data?.body },
    });
    if (cb) {
      cb(data?.data?.body);
    }
    if (data?.data?.status === 'CREATED') toaster('success', data?.data?.message);
    else toaster('error', data?.data?.message);
  } catch (e) {
    dispatch({ type: actionType.LOADER_FALSE });
    toaster('error', data?.data?.message);
  }
};
